import { vibrate_duration } from '@phi/constants';
import styles from './index.module.scss';
import { utility } from '@phi/components';
import { defineComponent, h, ref } from 'vue';

const indicate = ref(false);

export function indicate_long_press() {
    if ('vibrate' in navigator)
        navigator.vibrate(vibrate_duration);
    indicate.value = true;
}

export const LongPressIndicator = defineComponent({
    setup() {
        function transition_end() {
            indicate.value = false;
        }

        return () => h('div', {
            class: {
                [styles.indicator]: true,
                [utility.important_opaque]: !indicate.value,
                [utility.entire_screen]: true,
                [utility.z_maximum]: true,
                [utility.absolute]: true,
                [utility.pointer_no]: true,
                [utility.faded]: true,
            },

            onTransitionend: transition_end,
        });
    },
});
